/**
 * 月の距離
 */
export type MonthDistance = number;

export const MONTH_DISTANCE_MIN = -3;
export const MONTH_DISTANCE_MAX = 3;

/**
 * MonthDistanceにaddValueを加算した結果を返す
 * @param target - 対象となる月
 * @param addValue - 加算する値
 */
export const addMonthDistance = (target: number, addValue: number): MonthDistance => {
  const result = target + addValue;
  return result as MonthDistance;
};
